function t(n, f) {
  return n === f || n !== n && f !== f;
}
export {
  t as default
};
